export default __webpack_public_path__ + "static/media/close-dark.d4acc1fa.svg";